export default "__VITE_ASSET__Bw9Vl1fl__"